import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=64c3e2b8&scoped=true"
import script from "./addressList.vue?vue&type=script&lang=js"
export * from "./addressList.vue?vue&type=script&lang=js"
import style0 from "./addressList.vue?vue&type=style&index=0&id=64c3e2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3e2b8",
  null
  
)

export default component.exports